import React from "react";
import { Alert } from "@amzn/awsui-components-react-v3";
import Link from "@amzn/awsui-components-react-v3/polaris/link";
import { TROUBLESHOOTING_SIM_LINK } from "../constants/constants";

interface ActivationRequiredProps {
    userStatus: string | null | undefined;
    children: React.ReactNode;
}

export default function ActivationRequired({ userStatus, children }: ActivationRequiredProps) {
    // No context provided (e.g. tests) or no account selected — pass through
    if (userStatus === undefined || !localStorage.getItem("account")) {
        return <>{children}</>;
    }

    // Status confirmed active — show content
    if (userStatus && userStatus.toLowerCase() === "active") {
        return <>{children}</>;
    }

    // Status could not be determined — infrastructure issue
    if (userStatus === null) {
        return (
            <Alert type="error" header="Unable to verify your account status">
                We could not retrieve your user status for this account. This may indicate an infrastructure issue.
                Please try refreshing the page. If the problem persists,{" "}
                <Link external href={TROUBLESHOOTING_SIM_LINK}>
                    cut a troubleshooting SIM
                </Link>{" "}
                or contact the service team via{" "}
                <Link external href="https://w.amazon.com/bin/view/CMLS/ContactUs/">
                    CMLS Contact Us
                </Link>.
            </Alert>
        );
    }

    // Non-active status — show activation banner
    return (
        <Alert type="warning" header="Account activation required">
            You need to activate your access to this account before you can use this page.
            Please go to <Link href="/account">My Account</Link> to activate your access.
        </Alert>
    );
}
